export enum SchoolCandidateInstitutionAdminSort {
  Child = 1,
  DateOfBirth = 2,
  Address = 3,
  DelayTemporaryExemption = 4,
  Status = 5,
  RequestType = 6,
  MinorityOrReligiousInstitution,
}
